<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="siteSelectClose"
    :append-to-body="true"
    class="abow_dialog"
  >
    <div class="select-sites" v-if="sitesConfig&&sites">
      <!--全部站点-->
      <div class="siteall-wrap select-item" v-if="sitesNumAndSelectNum">
        <div>
           <el-checkbox
            :indeterminate="isAllSiteIndeterminate"
            v-model="checkAllSites"
            @change="checkAllSitesChange"
            class="all-sites"
          >
            全部站点
            <div style="text-align: center;display:inline">
            ({{ sitesNumAndSelectNum.selectnum }}/{{
              sitesNumAndSelectNum.sitesnum
            }})
          </div>
          </el-checkbox>
        </div>
      </div>
      <!--站点级别控制站点的显示状态-->
      <div class="sitelevel-wrap select-item">
        <div class="label">
          <el-checkbox
            v-model="checkAllSiteLevel"
            @change="handleAllSiteLevelChange"
            class="all-sites"
          >
            全部站点级别({{ sitesNumAndSelectNum.selectnum }}/{{
              sitesNumAndSelectNum.sitesnum
            }}) :
          </el-checkbox>
        </div>
        <div class="content">
           
          <el-checkbox
            v-for="(item, siteLevelId) in sites.siteLevel"
            :label="siteLevelId"
            :key="siteLevelId"
            :value="item.IsSelect"
            @change="(checked) => handleSiteLevelChange(checked, item)"
          >
            {{ item.LevelStr }}({{ item.sitesnum }})
          </el-checkbox>
        </div>
      </div>

      <!--介质类型-->
      <div class="medium-wrap select-item">
        <div class="label">
          <el-checkbox
            v-model="checkAllMedium"
            @change="handleAllMediumChange"
            class="all-sites"
          >
            全部介质({{ sitesNumAndSelectNum.selectnum }}/{{
              sitesNumAndSelectNum.sitesnum
            }}) :
          </el-checkbox>
        </div>
        <div class="content" v-if="sites.mediumList">
          
          <el-checkbox
            v-for="(item, mediumId) in sites.mediumList"
            :label="mediumId"
            :key="mediumId"
            :value="item.selectMedium"
            @change="(checked) => handleMediumChange(checked, item)"
          >
            {{ item.MediumStr }}({{ item.sitesnum }})
            <img v-bind:src="baseUrl + '/img/' + item.Icons" />
          </el-checkbox>
        </div>
      </div>

      <!--分组-->
      <div class="group-wrap select-item">
        <div class="label">
          <el-checkbox
            v-model="checkAllGroup"
            @change="handleAllGroupChange"
            class="all-sites"
          >
            全部分组({{ sitesNumAndSelectNum.selectnum }}/{{
              sitesNumAndSelectNum.sitesnum
            }}) :
          </el-checkbox>
        </div>
        <div class="content">
          <el-checkbox
            v-for="(item, groupId) in showGroup"
            :label="groupId"
            :key="groupId"
            :value="item.selectStatus == 2"
            @change="(checked) => handleGroupChange(checked, item)"
          >
            {{ item.GroupName }}({{ item.sitesnum }})
          </el-checkbox>
        </div>
      </div>

      <!--全部站点-->
      <div class="group-wrap select-item"
        v-for="(groupName, groupId) in sites.groupList"
        :label="groupName"
        :key="groupId"
      >
        <div class="label">
          {{ groupName }}
        </div>
        <div class="content">
          <el-checkbox
            v-for="(item, siteNo) in showSiteList[groupId]"
            :label="item.SiteNo"
            :key="siteNo"
            :value="item.now"
            @change="(checked) => handleSiteChange(checked, item)"
          >
            {{ item.SiteNo }}/{{ item.SiteName }}
            <img
              v-bind:src="
                baseUrl + '/img/' + sites.mediumList[item.MediumType].Icons
              "
            />
          </el-checkbox>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="siteSelectCancel">取 消</el-button>
      <el-button type="primary" @click="siteSelectCompleted">确 定</el-button>
    </span>
  </el-dialog>
  
</template>
<script>
/**
 * 站点筛选的逻辑还是蛮变态的，详情可以参考知识本PhEMS详细设计_20200807
 */
export default {
  name: "siteselect",
  props: ["show","page"],
  data() {
    return {
      baseUrl: this.$store.state.assetsUrl,
      checkAllSites: true, // 全部站点的选中状态
      isAllSiteIndeterminate: false, // 全部站点是否处于半选状态
      sitesNumAndSelectNum: {}, // 全部站点及全部选择站点

      showSiteList: {}, // 站点显示列表，只包含了站点及其分组信息，没有相应的介质信息，和传入的sites还是有区别的，比如站点是否选中等
      sites:null, // 将站点配置进行拷贝，保存初始修改状态

      checkAllMedium: false, // 全部介质选中状态
      isAllMediumIndeterminate: false, // 全部介质是否处于半选状态
      showGroup: {}, // 分组显示列表

      checkAllGroup: false, // 全部分组的选中状态
      isAllGroupIndeterminate: false, // 全部分组是否处于半选状态

      checkedSites: [], // 全部选中的站点

      checkAllSiteLevel:false, // 全部站点级别
      isAllSiteLevelIndeterminate:false, // 全部站点级别是否显示为半选状态
    };
  },
  computed:{
    // 站点选择对话框是否显示
    dialogVisible(){
      return this.show;
    },
    // 站点配置
    sitesConfig(){
      // 获取当前页面相关的站点配置
      return this.$store.getters.getSitesConfigByPage(this.page);
    }
  },
  watch:{
    "sitesConfig":function(){
      // 重新初始化站点列表
      this.initSiteList();
    }
  },
  mounted() {
    // 初始化站点列表
    this.initSiteList();
  },
  methods: {
    // 生成站点列表
    initSiteList() {
      // 深拷贝站点的选择状态,便于保存站点的初始状态
      if(!this.sitesConfig){
        return;
      }
      this.sites=JSON.parse(JSON.stringify(this.sitesConfig)); // 进行深拷贝，防止修改原始对象

      // 站点级别选中状态
      let sitelevelList=this.sites.siteLevel;
      let siteLevelListNum = Object.keys(sitelevelList).length; // 全部介质的数量
      let selectSiteLevel=0; // 选中的站点级别的数量
      for(let sitelevelId in sitelevelList){
        let siteLevel=sitelevelList[sitelevelId];
        if(siteLevel.IsSelect){ // 如果有一个站点级别没有选中
          selectSiteLevel++
        }
      }
      // 如果有一个站点级别没有选中，则全部站点级别显示为半选状态
      if (selectSiteLevel == siteLevelListNum) {
        this.checkAllSiteLevel = true;
        this.isAllSiteLevelIndeterminate = false;
      } else if (selectSiteLevel == 0) {
        this.checkAllSiteLevel = false;
        this.isAllSiteLevelIndeterminate = false;
      } else {
        this.checkAllSiteLevel = false;
        this.isAllSiteLevelIndeterminate = true;
      }


      // 判断是否有siteGroup对象
      if(!this.sites.siteGroup){
        // 生成分组对象
        let showGroup = {}; // 显示的分组内容
        let groupList = this.sites.groupList;
        for (let groupId in groupList) {
          let name = groupList[groupId];
          showGroup[groupId] = {
            GroupName: name,
            GroupId: groupId,
            selectnum: 0, // 分组中站点选中数量
            sitesnum: 0, // 分组中站点数量
            selectStatus: 2, // 分组的选中状态,0为未选择状态，1为半选择状态，2为全选状态
          };
        }

        // 设置全部分组及状态
        this.checkAllGroup=true; // 全部站点级别
        this.isAllGroupIndeterminate=false; // 全部站点级别是否显示为半选状态
        // 保存初始化后的分组的内容
        this.sites.siteGroup = showGroup;
      }
      

      // 介质类型是否处于选中状态
      let mediumList = this.sites.mediumList;
      let medimNum = Object.keys(mediumList).length; // 全部介质的数量
      let selectMediumNum = 0; // 选中的介质数量
      for (let mediumId in mediumList) {
        let item = mediumList[mediumId];

        // 判断当前介质是否显示,当有一个介质不是全选状态的时候，那么全部介质的选择状态就为半选状态
        if (item.selectMedium) {
          selectMediumNum++;
        }

        // 初始化相应站点的介质数量和选择的介质数量
        item.sitesnum = 0;
        item.selectnum = 0;
      }
      // 如果全部介质都选中了，则将全部介质按钮置为全选状态
      if (selectMediumNum == medimNum) {
        this.checkAllMedium = true;
        this.isAllMediumIndeterminate = false;
      } else if (selectMediumNum == 0) {
        this.checkAllMedium = false;
        this.isAllMediumIndeterminate = false;
      } else {
        this.checkAllMedium = false;
        this.isAllMediumIndeterminate = true;
      }

      // 执行站点状态改变方法
      this.siteChange("site");
    },
    // 全部站点选择
    checkAllSitesChange(val) {
      // 修改全部站点级别状态
      let siteLevellist = this.sites.siteLevel;
      for (let level in siteLevellist) {
        let item = siteLevellist[level];
        if (val) {
          item.IsSelect = true;
        } else {
          item.IsSelect = false;
        }
      }

      // 修改全部介质状态
      let mediumList = this.sites.mediumList;
      for (let mediumId in mediumList) {
        let mediumItem = mediumList[mediumId];
        if (val) {
          mediumItem.selectMedium = true;
        } else {
          mediumItem.selectMedium = false;
        }
      }

      // 修改全部分组状态
      let showGroup = this.sites.siteGroup;
      for (let groupId in showGroup) {
        let item = showGroup[groupId];
        if (!val) {
          item.selectnum = 0;
          item.selectStatus = 0;
        } else {
          item.selectnum = item.sitesnum;
          item.selectStatus = 2;
        }
      }

      // 设置全部介质和全部分组标志
      if (!val) {
        this.checkAllMedium = false; // 全部介质选中状态
        this.checkAllGroup = false; // 全部分组的选中状态
        this.checkAllSiteLevel=false; // 全部站点级别选中状态
      } else {
        this.checkAllMedium = true; // 全部介质选中状态
        this.checkAllGroup = true; // 全部分组的选中状态
        this.checkAllSiteLevel=true; // 全部站点级别选中状态
      }
      this.isAllMediumIndeterminate = false; // 全部介质是否处于半选状态
      this.isAllGroupIndeterminate = false; // 全部分组是否处于半选状态
      this.isAllSiteLevelIndeterminate=false; // 全部站点级别是否显示为半选状态

      // 执行站点状态改变事件
      this.siteChange();
    },
    // 全部站点级别改变事件
    handleAllSiteLevelChange(val){
      this.checkAllSiteLevel = val ? true : false; // 全部介质的选中状态
      this.isAllSiteLevelIndeterminate = false; // 取消半选状态

      // 修改各个站点级别的选中状态
      let sitelevelList = this.sites.siteLevel;
      for (let sitelevelId in sitelevelList) {
        let sitelevel = sitelevelList[sitelevelId];
        if (val) {
          sitelevel.IsSelect = true;
        } else {
          sitelevel.IsSelect = false;
        }
      }

      // 执行站点状态改变事件
      this.siteChange();
    },
    // 单个站点级别选择事件
    handleSiteLevelChange(value, item) {
      if (!value) {
        item.selectnum = 0;
        item.IsSelect = false;
      } else {
        item.selectnum = item.sitesnum;
        item.IsSelect = true;
      }

      // 判断全部站点级别的选中状态
      let siteLevel = this.sites.siteLevel;
      let fraction = 0; // 标志是否全部选中
      for (let siteLevelId in siteLevel) {
        let siteLevelItem = siteLevel[siteLevelId];
        if (siteLevelItem.IsSelect) {
          fraction++;
        }
      }
      // 判断全部站点级别按钮处于什么状态，如果选择的站点级别数量和总站点级别数量相等，则处于全选状态
      // 如果选择的站点级别数量为零，则出去全部选状态
      // 如果选择的站点级别数量介于两者之间，则处于半选状态
      if (fraction == 0) {
        this.checkAllSiteLevel = false;
        this.isAllSiteLevelIndeterminate = false;
      } else if (fraction == Object.keys(siteLevel).length) {
        this.checkAllSiteLevel = true;
        this.isAllSiteLevelIndeterminate = false;
      } else {
        this.checkAllSiteLevel = false;
        this.isAllSiteLevelIndeterminate = true;
      }
      // 执行站点状态改变
      this.siteChange();
    },
    // 全部介质选中事件
    handleAllMediumChange(val) {
      this.checkAllMedium = val ? true : false; // 全部介质的选中状态
      this.isAllMediumIndeterminate = false; // 取消半选状态
      // 判断全部介质状态
      let mediumList = this.sites.mediumList;
      for (let mediumId in mediumList) {
        let mediumItem = mediumList[mediumId];
        if (val) {
          mediumItem.selectMedium = true;
        } else {
          mediumItem.selectMedium = false;
        }
      }

      // 执行站点状态改变方法
      this.siteChange();
    },
    // 单个介质选中事件
    handleMediumChange(value, item) {
      // 改变介质的选择状态以及初始化相应站点选择数量
      if (!value) {
        item.selectnum = 0;
        item.selectMedium = false;
      } else {
        item.selectnum = item.sitesnum;
        item.selectMedium = true;
      }

      // 判断全部介质状态
      let mediumList = this.sites.mediumList;
      let fraction = 0; // 标志是否全部选中
      for (let mediumId in mediumList) {
        let mediumItem = mediumList[mediumId];
        if (mediumItem.selectMedium) {
          fraction++;
        }
      }
      // 判断全部介质按钮处于什么状态，如果选择的介质数量和总介质数量相等，则处于全选状态
      // 如果选择的介质数量为零，则出去全部选状态
      // 如果选择的介质数量介于两者之间，则处于半选状态
      if (fraction == 0) {
        this.checkAllMedium = false;
        this.isAllMediumIndeterminate = false;
      } else if (fraction == Object.keys(mediumList).length) {
        this.checkAllMedium = true;
        this.isAllMediumIndeterminate = false;
      } else {
        this.checkAllMedium = false;
        this.isAllMediumIndeterminate = true;
      }

      // 执行站点状态改变方法
      this.siteChange();
    },

    // 全部分组选中事件
    handleAllGroupChange(val) {
      // 遍历显示的分组内容
      let showGroup = this.showGroup;
      for (let groupId in showGroup) {
        let item = showGroup[groupId];
        if (!val) {
          item.selectnum = 0;
          item.selectStatus = 0;
        } else {
          item.selectnum = item.sitesnum;
          item.selectStatus = 2;
        }
      }

      // 执行站点状态改变方法
      this.siteChange();
    },
    // 单个分组选中事件
    handleGroupChange(val, item) {
      if (!val) {
        item.selectnum = 0;
        item.selectStatus = 0;
      } else {
        item.selectnum = item.sitesnum;
        item.selectStatus = 2;
      }

      // 遍历显示的分组内容
      let showGroup = this.showGroup;
      let fraction = 0; // 标志是否全部选中
      for (let groupId in showGroup) {
        let item = showGroup[groupId];
        if(item.selectStatus==2){
          fraction++;
        }
      }
      // 判断全部分组按钮处于什么状态，如果选择的分组数量和总分组数量相等，则处于全选状态
      // 如果选择的分组数量为零，则出去全部选状态
      // 如果选择的分组数量介于两者之间，则处于半选状态
      if (fraction == 0) {
        this.checkAllGroup= false;
        this.isAllGroupIndeterminate = false;
      } else if (fraction == Object.keys(showGroup).length) {
        this.checkAllGroup = true;
        this.isAllGroupIndeterminate = false;
      } else {
        this.checkAllGroup = false;
        this.isAllGroupIndeterminate = true;
      }

      // 执行站点状态改变方法
      this.siteChange();
    },
    // 站点选中的点击事件
    handleSiteChange(val, item) {
      item.now = val ? val : false;

      // 执行站点状态改变方法
      this.siteChange("site");
    },

    // 处理站点的选中与显示隐藏
    siteChange(evetype) {
      // 初始化站点级别及其选择状态
      let siteLevellist = this.sites.siteLevel;
      for (let level in siteLevellist) {
        let item = siteLevellist[level];
        // 初始化相应站点级别选择的站点数量
        item.selectnum = 0;
        item.sitesnum = 0;
      }

      // 初始化介质类型及其选择状态
      let mediumList = this.sites.mediumList;
      for (let mediumId in mediumList) {
        let item = mediumList[mediumId];

        // 初始化相应介质选择的站点数量
        item.selectnum = 0;
        item.sitesnum = 0;
      }

      let siteGroupList = this.sites.siteGroup; // 当前分组内容及其状态

      let tempGroup = {}; // 临时分组状态

      let siteList = this.sites.siteList; // 站点列表

      // 遍历全部站点，查看是否全部站点已经选中，如果没有选中，则全部站点的选项为半选状态

      let tempShowSiteList = {}; // 临时站点选择

      // 全部站点以及已选站点数量
      let sitesNumAndSelectNum = {
        sitesnum: 0,
        selectnum: 0,
      };
      // 遍历站点数组
      for (let groupId in siteList) {
        let groupSites = siteList[groupId];

        // 初始化分组显示内容
        if (!tempGroup[groupId]) {
          tempGroup[groupId] = siteGroupList[groupId];
          tempGroup[groupId].selectnum = 0;
          tempGroup[groupId].sitesnum =0;
        }

        // 循环遍历所有站点，判断是否显示隐藏以及选中状态
        for (let siteId in groupSites) {
          sitesNumAndSelectNum.sitesnum++; //全部站点数递增

          let siteItem = groupSites[siteId];

          // 如果选中了相应的介质类型并且如果选中了相应的站点级别，则属于该站点级别并且属于该介质类型的站点将被显示
          let mediumId = siteItem.mediumId; //介质类型
          let siteLevel = siteItem.siteLevel||2; //站点级别，默认为0
          let sitegroup=siteItem.GroupId||0; // 站点分组，默认为0

          // 相应介质的数量
          mediumList[mediumId].sitesnum++;

          // 相应站点级别的数量
          siteLevellist[siteLevel].sitesnum++;

          // 相应分组站点数量增加
          tempGroup[groupId].sitesnum++;

          
          tempShowSiteList[groupId] = tempShowSiteList[groupId] || {}; // 初始化临时站点显示列表
          tempShowSiteList[groupId][siteId] = siteItem; // 保存需要显示的站点

          if(evetype!="site"){ // 如果点击的不是站点类型
            // 当相应的站点级别，介质类型，以及分组都选中时，站点才会选中
            if (
              mediumList[mediumId].selectMedium &&
              siteLevellist[siteLevel].IsSelect &&
              siteGroupList[sitegroup].selectStatus==2
            ) {
              siteItem.now=true;
            } else {
              // 判断相应的介质、类型或者是分组是否处于半选状态，如果处于半选状态，择不进行状态更新(这是待开发需求)
              siteItem.now=false;
            }
          }
          
        
          // 根据站点是否被选中,增加相应的数量
          if (siteItem.now) {
            tempGroup[groupId].selectnum++; // 站点选中数量递增

            // 相应介质的站点的选择数量递增
            mediumList[mediumId].selectnum++;
            
            // 相应站点级别的选择数量增加
            siteLevellist[siteLevel].selectnum++;          

            // 全部选中站点数递增
            sitesNumAndSelectNum.selectnum++;
          }

          // 修改站点级别的状态
          // if(siteLevellist[siteLevel].selectnum==siteLevellist[siteLevel].sitesnum){
          //   siteLevellist[siteLevel].IsSelect=true;
          // }else if(siteLevellist[siteLevel].selectnum==0){
          //   siteLevellist[siteLevel].IsSelect=false;
          // }
        }
      }

      // 更改全部站点按钮的状态
      if (
        sitesNumAndSelectNum.selectnum == sitesNumAndSelectNum.sitesnum &&
        sitesNumAndSelectNum.selectnum != 0
      ) {
        this.checkAllSites = true;
        this.isAllSiteIndeterminate = false;
      } else if (sitesNumAndSelectNum.selectnum == 0) {
        this.checkAllSites = false;
        this.isAllSiteIndeterminate = false;
      } else {
        this.isAllSiteIndeterminate = true;
        this.checkAllSites = false;
      }

      // 更新全部站点及选择站点数量
      this.sitesNumAndSelectNum = sitesNumAndSelectNum;

      // 更新分组状态
      this.showGroup = tempGroup;

      // 更新全部站点的状态
      this.showSiteList = tempShowSiteList;

    },
    // 站点选择完成
    siteSelectCompleted(){
      // 触发父组件站点数据更新状态
      this.$emit("siteSelectCompleted",this.showSiteList);

      // 更新站点选中状态
      let temp=this.sites;
      // 如果独立设置了站点页面，则进行单独存储
      if(this.page){
        temp={
          page:this.page,
          config:this.sites
        }
      }
      this.$store.commit("sitesConfigPage",temp);

      // 关闭对话框
      this.$emit("update:show",false);
    },
    // 站点选择关闭按钮
    siteSelectClose(){
      // 判断用户是否做过修改
      let originSite=this.sitesConfig.siteList;
      let targetSite=this.showSiteList;
      let updateFlag=false; // 站点选中状态更新标志

      // 遍历站点，查询用户是否改变了站点的选择状态
      for(let groupId in originSite){
        let groupSites=originSite[groupId];
        for(let siteId in groupSites){
          let siteItem=groupSites[siteId];
          // 如果原始站点选择状态和修改后的站点选择状态不一致，则认定为用户已经修改了站点选择
          if(siteItem.now!=targetSite[groupId][siteId].now){
            updateFlag=true;
          }
        }
      }
      // 如果站点选中状态改变了，则弹出提示框
      if(updateFlag){
        this.$confirm("您确认要关闭吗？关闭后，您所作的操作将不予保存。")
        .then(() => {
          // 站点取消
          this.siteSelectCancel();
        })
        .catch(() => {});
      }else{
        // 站点取消
        this.siteSelectCancel();
      }
      

    },
    // 站点选择取消
    siteSelectCancel(){
      // 关闭站点筛选组件
      this.$emit("update:show",false);
      // 重新执行站点筛选
      this.initSiteList();
    }
  },
};
</script>
<style lang="stylus">
.select-sites {
  .select-item {
    margin: 15px 0;
    position: relative;

    .label {
      width: 100px;
      display:inline-block;
      float: left;
      // position:absolute;
      left:0;

      .el-checkbox__label{
        color:#000;
      }
    }

    .content {
      width: auto;
      margin-left: 180px;
      min-height: 30px;

      img {
        width: 16px;
        height: 16px;
        margin-left: 5px;
        vertical-align: middle;
      }
    }

    /** 半选状态 */
    .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      // background-color:#409EFF;
      background-color:#fff;
      color:#409EFF;
    }

    .el-checkbox__input.is-indeterminate .el-checkbox__inner::before{
      background-color:#409EFF;
      height: 15px;
      width: 15px;
      border-radius: 20px;
      left: -1px;
      right: 0;
      top: -1px;
    }
  }

  .sitelevel-item-wrap {
    display: inline-block;
  }

  .medium-item-wrap {
    margin-left: 25px;
    display: inline-block;
  }

  .siteList-item-wrap {
    label {
      margin: 0 20px 10px 0;
    }
  }
  .el-checkbox{
    margin-bottom:15px
  }
}
</style>
